<template>
    <div class="news-results">
        <news-card
            v-for="item in data"
            :key="item.code"
            :card="item"
        />
    </div>
</template>
<script setup>
import NewsCard from '@/components/NewsCard'

defineProps({
    data: {
        type: Array
    }
})
</script>

<style lang="scss">
.news-results{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    @include gap-level(L);

    @include breakpoint(v-tablet){
        grid-template-columns: repeat(2, 1fr);
    }
    @include breakpoint(mobile){
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>

